<ng-container *ngIf="time$ | async as time">
  <div class="mui-hero-current-time">
    <div class="mui-hero-current-time__date">{{ (time$ | async)?.date }}</div>
    <div class="mui-hero-current-time__clock">{{ (time$ | async)?.clock }}</div>
  </div>
</ng-container>
